<template>
  <div class="row d-flex flex-column align-center py-5">
    <h4 class="text-center fw-bold mb-4 d-none">REGISTER</h4>
    <div class="col-lg-6 d-flex flex-column align-center" style="position: relative;">
      <v-card v-if="registerbox" class="register-card" style="border-radius:7px;box-shadow: 0px 0px 8px 0px black;"
        outlined>
        <div class="row d-flex align-items-center justify-content-center">
          <div class="col-md-12 main-page">
            <div class="bg-light main-page mx-auto shadow-none p-3"
              style="background-color:#f8b2b2; width: 100%; height: auto;">
              <!-- <div class="col-12 pe-1 pt-1 d-flex justify-end" @click="closeRegisterBox()">
                  <v-icon size="small" style="color:navy; cursor:pointer">mdi-close-circle</v-icon>
                </div> -->

              <div class="d-flex align-center justify-content-between w-100">
                <div class="d-flex flex-row align-center">
                  <div class="m-2 ms-0 rounded-circle lockIcon d-flex align-center justify-center">
                    <i class="bi bi-person-plus fs-4 p-4"></i>
                  </div>
                  <div>
                    <h4 class="m-0">{{ $t("registerContents.signUp")}}</h4>
                    <p class="m-0 f-size-12">{{ $t("loginContents.subHaed") }}</p>
                  </div>
                </div>
                <div class="d-flex align-center justify-end pe-2" @click="redirectHome()" style="cursor:pointer;">
                  <v-icon size="22">mdi-close</v-icon>
                </div>
              </div>

              <v-form ref="form" class="py-3 form-data" v-model="valid" @submit.prevent="submitForm" v-if="regForm">
                <div class="row">
                  <div class="col-md-4 col-12">
                    <v-text-field v-model="personal.firstName" :rules="firstName" :label="this.$t('registerContents.labels.firstName')" variant="outlined"
                      :placeholder="this.$t('registerContents.placeholder.name')"></v-text-field>
                  </div>
                  <div class="col-md-4 col-12">
                    <v-text-field v-model="personal.middleName" :label="this.$t('registerContents.labels.middleName')" variant="outlined"
                      :placeholder="this.$t('registerContents.placeholder.name')"></v-text-field>
                  </div>
                  <div class="col-md-4 col-12">
                    <v-text-field v-model="personal.lastName" :rules="lastName" :label="this.$t('registerContents.labels.lastName')" variant="outlined"
                      :placeholder="this.$t('registerContents.placeholder.name')"></v-text-field>
                  </div>
                <!-- <span style="color: red;">invalid Username</span><br> -->

                </div>
                <div class="row">
                  <div class="col-md-6 col-12">
                  <v-text-field v-model="personal.email" :rules="eMail" :label="this.$t('registerContents.labels.emailId')" placeholder="johndoe@gmail.com"
                    type="email" variant="outlined"></v-text-field>
                  <!-- <span style="color: red;">invalid Email</span><br> -->
                  </div>
                  <div class="col-md-6 col-12">
                  <v-text-field v-model="personal.phoneNumber" :label="this.$t('registerContents.labels.phoneNumber')" :placeholder="this.$t('registerContents.placeholder.phoneNo')"
                    type="text" variant="outlined"></v-text-field>
                    </div>
                  </div>
                <div class="row">
                  <div class="col-md-6 col-12">
                  <v-text-field v-model="personal.password" :rules="passWord" :label="this.$t('registerContents.labels.password')"
                    :placeholder="this.$t('registerContents.placeholder.password')" variant="outlined" required
                    :append-inner-icon="visible ? 'mdi-eye' : 'mdi-eye-off'" :type="visible ? 'text' : 'password'"
                    @click:append-inner="visible = !visible"></v-text-field>
                  <!-- <span style="color: red;">invalid password</span> -->
                  </div>
                <div class="col-md-6 col-12">
                <v-text-field v-model="personal.rePassword" :rules="repassWord" :label="$t('registerContents.labels.rePassword')"
                  :placeholder="this.$t('registerContents.placeholder.rePassword')" variant="outlined" required
                  :append-inner-icon="visible1 ? 'mdi-eye' : 'mdi-eye-off'" :type="visible1 ? 'text' : 'password'"
                  @click:append-inner="visible1 = !visible1"></v-text-field>
                <!-- <span style="color: red;">invalid Re-password</span> -->
                </div>
                </div>
                

                <div class="d-flex my-4">
                  <div class="col-9 d-flex justify-end">
                    <v-btn width="70%" :disabled="btnDisabled" type="submit"
                      style="background-color:#26225e; color:white">{{ $t("registerContents.buttonsLink.submit") }}</v-btn>
                  </div>
                  <div class="col-3 ps-3 d-flex justify-end">
                    <v-progress-circular v-if="loadRegister" :width="3" style="color:navy"
                      indeterminate></v-progress-circular>
                  </div>
                </div>
                <!-- <v-divider></v-divider> -->
                <div class="d-flex flex-row justify-center text-center">
                  <p class="m-0" style="font-weight: 600;">{{ $t("registerContents.buttonsLink.alreadyAccount") }}
                    <span style="cursor: pointer;"> &nbsp;
                    <a href="/login" style="color:navy;text-decoration:none;text-align:end;font-weight:600;">{{ $t("registerContents.buttonsLink.login") }}</a>
                  </span>
                  </p>
                  <!-- <span style="cursor: pointer;"> &nbsp;
                    <a href="/login" style="color:navy;text-decoration:none;text-align:end;font-weight:600;">Login</a>
                  </span> -->

                </div>
              </v-form>


              <div v-if="regMsg">
                <div class="d-flex justify-center align-center p-3">
                  <v-icon color="success" size="50">mdi-check-circle-outline</v-icon>
                  <h4 class="text-success ps-2 m-0"> {{ $t("registerContents.successNotify.text2") }}...</h4>
                </div>
                <div class="d-flex justify-center align-center p-3">
                  <p>{{ registerMsg }}</p>
                </div>
              </div>
                <div class="d-flex justify-center w-100" v-if="regMsg">
                  <v-btn text="Return To Home" to="/" style="background-color:#26225e; color:white !important;"></v-btn>
                  <v-btn text="Login" to="/login" style="background-color:#26225e; color:white !important;"></v-btn>
                </div>
            </div>
          </div>
        </div>
      </v-card>
    </div>
      <v-dialog v-model="regErr" persistent>
    <div class="d-flex justify-center">
      <v-card class="p-4">
        <h6 class="text-center">{{ errorMsg }}</h6>
        <div class="d-flex mt-3 justify-center">
          <v-btn @click="closeDialog()" color="#26225e">{{ $t("errorMsg.buttons.tryAgain") }}</v-btn>
        </div>
      </v-card>
    </div>
  </v-dialog>
  </div>

  <!-- <div v-if="loginSection">
      <loginCom></loginCom>
    </div> -->
  <div class="text-center" v-if="dataloader">
    <dataloader></dataloader>
  </div>
</template>

<script>
// import loginCom from '@/components/loginCom.vue';
import axios from 'axios';
//   import dataloader from "@/components/dataLoder.vue";
import { getConfigDataFromLocalStorage } from '@/localStorageData/localStorageUtil.js';

export default {
  components: {
    // loginCom
    //   dataloader,
  },
  data() {
    return {
      dataloader: true,
      valid: false,

      registerbox: true,
      loginSection: true,
      terms: false,
      visible: false,
      visible1: false,

      regForm: true,
      regMsg: false,
      regErr:false,
      errorMsg:"",
      registerMsg: "",
      loadRegister: false,
      btnDisabled: false,
      username:"",
      personal: {
        firstName: "",
        middleName:"",
        lastName:"",
        email: "",
        password: "",
        rePassword: "",
        phoneNumber:""
      },
      data1: {
        "request_type": "user_register",
        "user_name": "",
        "email": "",
        "password": "",
        "portal_id": "",
        "portal_group_id": "",
        "user_id": "",
      },


      firstName: [
        v => !!v || 'Please enter your First Name',
        v => (v.length >= 3) || 'Name must be greater than 3 ',
      ],
       middleName: [
        v => !!v || 'Please enter your Middle Name',
        v => (v.length >= 3) || 'Name must be greater than 3 ',
      ],
       lastName: [
        v => !!v || 'Please enter your Last Name',
      ],

      eMail: [
        v => !!v || 'E-mail is required',
        v => /.+@.+/.test(v) || 'E-mail must be valid',
      ],
      phone_no:[
        v => /^[0-9]*$/.test(v) || 'Only numbers are allowed',
      ],

      passWord: [
        v => !!v || 'Please enter your Password',
        // v => (v && v.length >= 8) || 'Password must be at least 8 characters',
        // v => (v && v.length <= 20) || 'Password must be less than 20 characters',
        // v => (v && /[a-z]/.test(v)) || 'Password must contain at least one lowercase letter',
        // v => (v && /[!@#$%^&*]/.test(v)) || 'Password must contain at least one special character'
      ],
      repassWord: [
        v => !!v || 'Please enter your Re-password',
        v => v === this.personal.password || 'Passwords do not match'
      ],

      // strResult: "0123456789",

      // user_reqId:"",


      registerReq: {
        "request_type": "user_register",
        "first_name": "",
        "middle_name":"",
        "last_name":"",
        "email": "",
        "password": "",
        "portal_id": "",
        "portal_group_id": "",
        "user_id": "",
        "token": "Tc7RQaX79Hrx5CFK",
        "portal_domain": "",
      },
      portal_group_id:"",
      portal_id:"",
      registerUrl: "",
      portal_domain:"",
    };
  },
  methods: {
    closeDialog(){
      setInterval(() => {
        location.reload();
      }, 200);
    },


    signInAgain() {
      this.loginSection = true
      this.registerbox = false
      console.log(this.loginSection, this.registerbox, "Workinglogin....")
    },
    // closeRegBox() {
    //         this.loginbox = false;
    //         this.$emit('close'); // Emit the 'close' event to the parent component
    //         console.log(this.loginbox, "1111111")
    //     },


    // onClickOutside() {
    //   this.registerbox = false
    // },

    redirectHome(){
      this.$router.push('/')
    },
    submitForm() {

      console.log(this.valid, 'oooooooooo')
      if (this.valid) {

        this.loadRegister = true
        this.btnDisabled = true

        // this.generateBookingRefId()

        console.log(this.personal, 'eeeee......')


        this.registerReq.first_name = this.personal.firstName
        this.registerReq.middle_name = this.personal.middleName
        this.registerReq.last_name = this.personal.lastName
        this.registerReq.email = this.personal.email
        this.registerReq.password = this.personal.password
        this.registerReq.user_id = this.personal.email
        this.registerReq.portal_id = this.portal_id
        this.registerReq.portal_group_id = this.portal_group_id
        this.registerReq.portal_domain = this.portal_domain

        console.log(this.registerReq, 'ffff.....')

        axios.post(this.registerUrl, this.registerReq, {
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(response => {

            if (response.data) {
              this.regForm = false
              this.regMsg = true
              console.log('Response:', response.data);
              console.log('Response-Msg:', response.data.register.message);
              this.registerMsg = response.data.register.message

              // this.registerbox = false
            }
          })


          .catch(error => {
            this.regErr = true;
            console.log(error.response.data.message, 'wejjfuoajk')
            // alert(`${error.response.data.message}`)
            this.errorMsg = error.response.data.message
            this.loadRegister = false
            this.btnDisabled = false
          });
      }
    },




    // getRandomChars(length) {
    //         let result = "";
    //         for (let i = 0; i < length; i++) {
    //             const randomIndex = Math.floor(Math.random() * this.strResult.length);
    //             result += this.strResult[randomIndex];
    //         }
    //         console.log(result, "result");
    //         return result;
    //     },
    //     getRandomInt(min, max) {
    //         return Math.floor(Math.random() * (max - min + 1)) + min;
    //     },

    //     generateBookingRefId() {
    //         const randomChars1 = this.getRandomChars(1);
    //         const randomNum = this.getRandomInt(10, 99);
    //         const randomChars2 = this.getRandomChars(1);

    //         this.registerReq.user_id = randomChars1 + randomNum + randomChars2;
    //         console.log(this.registerReq.user_id, 'this.booking_refId ')
    //     },




    closeRegisterBox() {
      this.registerbox = false;
      this.$emit('close'); // Emit the 'close' event to the parent component
      console.log(this.registerbox, '00000')
    },



    getConfig() {
      this.dataloader = false
      // let portalLocal = localStorage.getItem("portalData")
      // let getConfigData1 = JSON.parse(portalLocal)
      const getConfigData1 = getConfigDataFromLocalStorage();
      if (getConfigData1) {
        this.registerUrl = getConfigData1.payload.portal_configuration.API_endpoints.b2cregister
        console.log(this.registerUrl, 'head...reg..1..')
        this.portal_id = getConfigData1.payload.portal_configuration.portal_id;
        this.portal_group_id = getConfigData1.payload.portal_configuration.portal_group_id;
        this.portal_domain = getConfigData1.payload.portal_configuration.portal_url.replace("https://","");
      }
    },
  },

  created() {
    this.getConfig();
  }
}
</script>



<style scoped>


.lockIcon{
    background-color: #F8A21A;
    height: 50px;
    width: 50px;
}

.main-page {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

/* .form-btn {
    padding-left: 40px;
    color: white;
  } */

.btn-box {
  background-color: transparent;
  margin: 5px;
  padding: 2px;
  box-shadow: none;
}

.btn-active {
  background-color: blueviolet;
  color: white;
}

>>>.v-input__details {
  display: block !important;
}
>>>.v-text-field input.v-field__input{
  padding: 5px 10px;
  min-height: 45px;
}

/* .v-checkbox .v-input__details {
    display: none;
  } */

/* Login Page End */

.register-card {
  width: 95%;
}

.form-data {
  width: 100%;
}

@media only screen and (max-width: 992px) {

  .form-btn {
    padding: 10px 0px 0px 0px !important;
    /* color: white; */
  }

  .btn-box,
  .pipe {
    color: blueviolet !important;
  }

  .btn-active {
    background-color: blueviolet;
    color: white !important;
  }
}

@media screen and (max-width:480px) {
  .register-card {
    width: 80%;
  }

  .form-data {
    width: 100%;
  }
}

@media screen and (min-width:480px) and (max-width:992px) {
  .register-card {
    width: 80%;
  }

  .form-data {
    width: 500px;
  }
}
a:visited{
  color:navy !important;
}
:deep(.v-text-field .v-input__details){
  padding-inline:5px !important;
}
</style>